export default __webpack_public_path__ + "static/media/arrow_back.dbcb6bdb.svg";